import { sendReactError } from 'services/app-service';
import { supportsWebp } from 'components/utils/image';
import { userAgent } from 'components/utils/device';

export const logError = (message, error = {}) => {
  if (BDAY_ENV !== 'prod') {
    console.error(`${message}\nError object: ${JSON.stringify(error, null, 4)}`);
  }
}

export const logInfo = (...args) => {
  if (BDAY_ENV !== 'prod') {
    console.info(...args);
  }
}

export const sendImageError = (e, props) => {
  const propsString = Object.keys(props).map(key => `${key}=${props[key]}`).join(", ");
  const canLoadWebp = supportsWebp();
  const message = `Trying to load image: currentSrc=${e && e.target && e.target.currentSrc ? e.target.currentSrc : 'undefined'}, ${propsString} and supportsWebp=${canLoadWebp}`;
  sendReactError({
    type: 'React boundary',
    error: message,
    version: global.version,
    parsedStack: '',
    componentStack: '',
    url: window ? window.location.href : '',
    agent: userAgent,
    date: new Date(),
    dimensions: {
      width: window ? window.innerWidth : '',
      height: window ? window.innerHeight : ''
    }
  });
}

export const sendCustomReactError = async (message) => {
  await sendReactError({
    type: 'React boundary',
    error: message,
    version: global.version,
    parsedStack: '',
    componentStack: '',
    url: window ? window.location.href : '',
    agent: userAgent,
    date: new Date(),
    dimensions: {
      width: window ? window.innerWidth : '',
      height: window ? window.innerHeight : ''
    }
  });
}